import { createProxyClient } from '../api/createProxyClient';

/**
 * WP API-Client. Immer über den BFF-Proxy `/proxy/wp/...`. Der BFF injiziert
 * server-seitig das GATEWAY_SHARED_SECRET (wp-api hat gateway-guard auf der
 * Admin-Fläche). Orbit ruft ausschließlich /v1/admin/*, /healthz und
 * /v1/monitoring — nie die WP-Instanz-Endpunkte (die brauchen X-Valitype-Key).
 *
 * #116/#114: nutzt jetzt die gemeinsame createProxyClient-Fabrik statt einer
 * eigenen ofetch-Kopie — Signatur/Verhalten unverändert.
 */
const client = createProxyClient('wp');

export const wpFetch = client.fetch;
export const isWpProxyEnabled = client.isEnabled;
